import axios from '../../../../utils/request';


function GET_LIST(params) {
    return axios.get("/statistics/Behavior/detailCustomerList",{
        params: {
           ...params
        }
    } )
}
export default {
    GET_LIST
};
